import React, { Component } from "react";
import ChevronDown from "./images/ChevronDown";

class InterviewMediaItem extends Component {
  render() {
    return (
      <div style={mediaWrapperStyle}>
        <div style={mediaIconStyle}>
          <p style={iconDateStyle}>{this.props.media.date}</p>
        </div>
        <div style={mediaStyle}>
          <p style={mediaHeaderStyle}>{this.props.media.title}</p>
          <p style={mediaSubHeaderStyle}>
            Interview of {this.props.media.authors}
          </p>
          <hr style={hr} />
          <div style={mediaAbstractStyle}>
            <p style={mediaAbstractTextStyle}>{this.props.media.text}</p>
          </div>
          <div style={mediaLinkStyle}>
            <a href={this.props.media.interviewlink}>
              <ChevronDown fill={"#777"} style={chevronStyle} />
              <p style={mediaLinkTextStyle}>View More</p>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mediaWrapperStyle = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  overflow: "auto",
};

const mediaIconStyle = {
  height: "200px",
  width: "160px",
  margin: "14px 10px 10px 20px",
  borderRadius: "6px",
  textAlign: "right",
};

const iconDateStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "16px",
  fontStyle: "italic",
  color: "#000",
  margin: "0px 10px 4px 10px",
};

const mediaStyle = {
  width: "550px",
  backgroundColor: "white",
  margin: "10px 30px 20px 10px",
  borderRadius: "6px",
};

const mediaHeaderStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
  margin: "10px 10px 2px 10px",
};

const mediaSubHeaderStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
  color: "#222",
  margin: "2px 10px 4px 10px",
};

const mediaAbstractStyle = {
  height: "255px",
  width: "500px",
  margin: "0px auto",
  textAlign: "justify",
  overflowY: "hidden",
  padding: "0px 10px 0px 10px",
};

const mediaAbstractTextStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
  fontStyle: "italic",
  height: "165px",
  color: "#555",
};

const mediaLinkStyle = {
  height: "60px",
  width: "160px",
  margin: "10px 10px 4px 360px",
  textAlign: "right",
};

const mediaLinkTextStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
};

const hr = {
  height: "2px",
  width: "80%",
  border: "0",
  borderTop: "1px solid #aaa",
  margin: "12px auto",
  padding: "0",
};

const chevronStyle = {
  float: "right",
  width: "14px",
  height: "14px",
  margin: "7px 0px 0px 4px",
  transform: "rotate(-90deg)",
};

export default InterviewMediaItem;
